import { createSlice } from '@reduxjs/toolkit';
import { fetchPropertyTypeList } from './thunk';

export type PropertyType = {
    _id: string
    propertyType: string
    isActive: boolean
}

export type paginationType = {

}

export type FilterType = {
    search: string,
    totalCount: number,
    page: number
    limit: number,
    sortBy: any,
    sortOrder: any,
}

interface PropertyTypeState {
    propertyTypeList: PropertyType[];
    filterData: FilterType,
    loading: {
        propertyTypeList: boolean
    }
}



const initialState: PropertyTypeState = {
    loading: {
        propertyTypeList: false
    },
    filterData: {
        search: "",
        totalCount: 0,
        page: 1,
        limit: 50,
        sortBy: "propertyType",
        sortOrder: "asc",
    },
    propertyTypeList: [],
};

const PropertyTypeSlice = createSlice({
    name: 'propertyType',
    initialState,
    reducers: {
        setUserList(state, action) {
            state.propertyTypeList = action.payload
        },
        setFilterData(state, action) {
            state.filterData = action.payload
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPropertyTypeList.pending, (state) => {
                state.loading.propertyTypeList = true;
            })
            .addCase(fetchPropertyTypeList.fulfilled, (state, action) => {
                state.loading.propertyTypeList = false;
                state.propertyTypeList = action.payload.data as any;
                state.filterData = {
                    ...state.filterData,
                    ...action.payload.filterData,
                };
            })
            .addCase(fetchPropertyTypeList.rejected, (state, action) => {
                state.loading.propertyTypeList = false;
            });
    },
});

export const { setUserList, setFilterData } = PropertyTypeSlice.actions;

export default PropertyTypeSlice.reducer;
